import React from "react";
import { IAccountContextType } from "./types";

/**
 * The context object on its own, with no provider imports. Readers that only
 * need `useContext(AccountContext)` (e.g. useActiveMarketData) import it from
 * here so they don't pull the provider's whole graph — AuthContext, i18n, chain
 * config — into every module, and every test, that touches market data.
 */
export const AccountContext = React.createContext<
  IAccountContextType | undefined
>(undefined);
